import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { AppointmentType } from './appointment-type.interface';
import { AppointmentTypeService } from './appointment-type.service';

const service = new AppointmentTypeService();

export interface AppointmentTypeState {
   appointmentTypes: Array<AppointmentType>;
}

const AppointmentTypeStore: Module<AppointmentTypeState, StoreState> = {
   namespaced: true,
   state: {
      appointmentTypes: [],
   },
   getters: {
      appointmentTypes: (state) => state.appointmentTypes,
   },
   mutations: {
      SET_APPOINTMENT_TYPE(state, appointmentTypes: Array<AppointmentType>) {
         state.appointmentTypes = appointmentTypes;
      },
   },
   actions: {
      async getAppointmentTypes(context, query: LocationQuery) {
         const response = await service.getAppointmentTypes(query);
         context.commit('SET_APPOINTMENT_TYPE', response.data);
         return response.data;
      },
   },
};

export default AppointmentTypeStore;
